import React, { useState } from 'react';

import constants from 'constants/constants';
import { Controller, useForm } from 'react-hook-form';

import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { TextInput } from 'components/DesignSystem/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';

import classes from './CreateNewViewModal.module.scss';

interface Props {
    isModalOpen: boolean;
    setIsModalOpen: (open: boolean) => void;
    onSubmit: (viewName: string) => Promise<void>;
}
interface FormValues {
    viewName: string;
}
const FORM_ID = 'create-new-schedule-view-form';

export const CreateNewViewModal = ({ isModalOpen, setIsModalOpen, onSubmit }: Props) => {
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const form = useForm<FormValues>({
        defaultValues: {
            viewName: '',
        },
    });
    const hideModal = () => {
        setIsModalOpen(false);
    };

    const submitForm = async (formValues: FormValues) => {
        const viewName = formValues.viewName;

        setIsLoadingSubmit(true);
        try {
            await onSubmit(viewName);
            hideModal();
        } finally {
            setIsLoadingSubmit(false);
        }
    };

    return (
        <div className={classes.createNewViewModal}>
            <Modal
                open={isModalOpen}
                onClose={hideModal}
                title={'Create a new schedule view'}
                width={constants.DEFAULT_MODAL_WIDTH}
                actions={
                    <>
                        <Button variant={'secondary'} onClick={hideModal}>
                            Cancel
                        </Button>
                        <Button isLoading={isLoadingSubmit} type={'submit'} form={FORM_ID}>
                            Create
                        </Button>
                    </>
                }
            >
                <form id={FORM_ID} onSubmit={form.handleSubmit(submitForm)}>
                    <div className={classes.inputWrapper}>
                        <label htmlFor={'viewName'}>View name:</label>
                        <Controller
                            render={({ field }) => (
                                <TextInput
                                    {...field}
                                    error={Boolean(form.formState.errors.viewName)}
                                    onClear={() => form.setValue('viewName', '')}
                                    placeholder={'Enter view name...'}
                                />
                            )}
                            name={'viewName'}
                            control={form.control}
                            rules={{
                                required: 'View name is required',
                            }}
                        />
                        {form.formState.errors.viewName && (
                            <CustomizedFormErrorMessage text={form.formState.errors.viewName.message} />
                        )}
                    </div>
                </form>
            </Modal>
        </div>
    );
};
